import { CheckIcon, ChevronDownIcon } from "@heroicons/react/outline";
import Button from "components/library/Button";
import { classNames } from "components/library/utils/classNames";
import { Tier, tiers } from "./PricingTable";

const PricingTiers = () => {
  const handleScrollToTable = () => {
    document
      .getElementById("pricing-table")
      ?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div className="dark">
      <div className="dark:bg-black">
        <div className="container-xl ">
          <div className="mx-auto py-24 md:pb-64 md:pt-80">
            <div className="grid md:grid-cols-3 md:px-0 lg:-mx-40 ">
              {tiers.map((tier) => (
                <PricingTier {...tier} key={tier.name} />
              ))}
            </div>
            {/* <div className="mx-12 mt-24 flex justify-center md:mt-64">
              <div className="text-14-22 text-gray-600 md:text-center">
                Characters refer to the individual text characters contained
                within your model prediction requests.
                <br />
                Additional characters are billed at $0.006 per thousand
                characters.
              </div>
            </div> */}
            <div className="mx-12 mt-24 flex justify-center md:mt-64">
              <div className="text-14-22 text-gray-300 md:text-center">
                <Button
                  IconRight={ChevronDownIcon}
                  styling="outline"
                  onClick={handleScrollToTable}
                  className=" text-gray-300 hover:border-white hover:text-gray-300"
                >
                  See all plans and features
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingTiers;

const PricingTier = ({
  name,
  description,
  price,
  pricePer,
  minimumUsers,
  offer,
  buttonText,
  href,
  features,
  highlighted,
}: Tier) => {
  return (
    <div
      className={classNames(
        "my-6 rounded-lg sm:m-0 sm:rounded-none md:my-12",
        "px-16 py-32 sm:py-48 md:px-28 lg:px-40",
        highlighted ? "bg-yellow-600" : "bg-gray-800/30 sm:bg-black",
        highlighted ? "text-gray-900" : "text-white"
      )}
    >
      <div
        className={classNames(
          "text-14-24 font-bold sm:text-18-28",
          highlighted ? "text-gray-900" : "text-gray-400"
        )}
      >
        {name}
      </div>
      <div
        className={classNames(
          "mb-16 min-h-[84px] pt-12 text-16-24 md:text-14-20 lg:text-16-24"
        )}
      >
        {description}
      </div>
      <div className="mt-4 flex items-end gap-8">
        <span className="font-display text-18-24 font-bold sm:text-24-32">
          {price}
        </span>
        {pricePer && (
          <span className="text-14-20 sm:text-18-28"> {pricePer}</span>
        )}
      </div>
      <div className="min-h-[32px]">
        {minimumUsers && (
          <span className="text-yellow-800">
            {" "}
            ({minimumUsers} users minimum)
          </span>
        )}
      </div>
      <div
        className={classNames(
          "mt-16 h-16 text-14-16 font-bold",
          !offer && "hidden sm:block"
        )}
      >
        {offer}
      </div>
      <div className="mt-24 hidden sm:block">
        <Button
          block
          className={
            highlighted
              ? "!bg-black hover:!bg-blue-700"
              : "!bg-white !text-black hover:!bg-blue-200"
          }
          styling="solid"
          size={40}
          square
          href={href}
        >
          {buttonText}
        </Button>
      </div>
      <hr
        className={classNames(
          "my-24 sm:my-40 sm:-mx-16 md:-mx-28 lg:-mx-40",
          highlighted ? "border-gray-900" : "border-gray-800"
        )}
      />
      <div className="flex flex-col gap-y-12">
        {features.map((feature) => (
          <div key={feature} className="flex items-center gap-x-12">
            <CheckIcon className="h-16 w-16 shrink-0 sm:h-20 sm:w-20" />
            <div className="text-14-16 sm:text-16-24 md:text-14-20 lg:text-16-24">
              {feature}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-24 sm:hidden">
        <Button
          className={classNames(
            "min-w-[160px]",
            highlighted ? "!bg-black" : "!bg-white !text-black"
          )}
          styling="solid"
          size={32}
          square
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};
